import React, {Component} from "react";
import {connect} from "react-redux";
import Module from "./Module.js";

class ModuleList extends Component {
    render() {
        let modulesDom;
        if (this.props.modules) {
            modulesDom = this.props.modules.map((mod, idx) => (
                <Module mod={mod} key={idx} collapseId={'m' + idx}/>
            ));
        } else {
            modulesDom = <div>No module has webcast video</div>;
        }
        return (
            <div className="module-list-container container">
                <h2 className="module-list-title">Modules</h2>
                <div role="tablist" aria-multiselectable="true">
                    {modulesDom}
                </div>
            </div>
        );
    }
}
let mapStateToProps = (state) => {
    return {
        modules: state.modules
    };
};
export default connect(mapStateToProps)(ModuleList);


// WEBPACK FOOTER //
// ./src/componentsBody/ModuleList.js